// removed by extract-text-webpack-plugin
module.exports = {"lesson-detail-float":"lesson-detail-float","title-section":"title-section","detail-section":"detail-section","controller-section":"controller-section"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Floats/LessonFloat/LessonFloat.scss
// module id = jhXJ
// module chunks = 0